<organization-top-navbar></organization-top-navbar>

<div class="block; relative isolate px-6 pt-10 lg:px-8">
  <div class="mx-auto max-w-5xl px-4 py-6">
    <div class="text-[#1B3777] text-center text-3xl lg:text-4xl  DisplayHeading self-stretch font-bold">{{
      'DRIVE_IN_BOOKING.COMPLETE_BOOKING' | transloco }}</div>
  </div>
</div>

<div class="container margin-auto">

  @if (showbookingDetailsForm) {
  <section class="img-container img-fluid pt-4">
    <div class="pt-4 pb-2">
      <div class=" text-[#1B3777] text-center text-xl md:text-2xl font-bold md:block w-97 leading-normal tracking-wide">
        @if ((driveInBookingForm.paymentRequired) == 'true') {
        <span>{{ 'PARKIFLY.SKAVSTA.HI' |
          transloco}}! {{ 'DRIVE_IN_BOOKING.PAYMENT_REQ_MSG' | transloco}}
        </span>
        }
        @if ((driveInBookingForm.paymentRequired) == 'false') {
        <span>{{ 'PARKIFLY.SKAVSTA.HI' |
          transloco}} {{ fullName }}!<br>{{ 'DRIVE_IN_BOOKING.PAYMENT_NOT_REQ_MSG' | transloco}}
        </span>
        }
      </div>
    </div>
  </section>
  }

  @if (showbookingDetailsForm) {
  <div class="margin-top-bottom-20">
    <form [formGroup]="bookingDetailsForm">
      <!-- Date Selection -->
      <div class="rounded-2xl flex-col justify-start items-start flex form-section-padding">
        <div class="mx-auto max-w-4xl">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <!-- START DATE -->
            <div
              class="low-opacity calender-border w-full p-4 bg-gray-100 rounded-4xl flex items-center justify-between">
              <div>
                <label class="block text-sm text-gray-600">{{ 'DRIVE_IN_BOOKING.START_DATE' | transloco
                  }}</label>
                <p class="text-gray-800">{{ bookingDetailsForm.controls['startDate'].value |
                  date:'yyyy/MM/dd' }}</p>
              </div>
              <mat-icon class="text-gray-500 ml-5">event</mat-icon>
            </div>
            <!-- START TIME -->
            <div
              class="low-opacity calender-border w-full p-4 bg-gray-100 rounded-4xl flex items-center justify-between">
              <div>
                <label class="block text-sm text-gray-600">{{ 'DRIVE_IN_BOOKING.START_TIME' | transloco
                  }}</label>
                <p class="text-gray-800">{{ bookingDetailsForm.controls['startTime'].value }}</p>
              </div>
              <mat-icon class="text-gray-500 ml-5">alarm</mat-icon>
            </div>
            <!-- END DATE -->
            <div class="w-full">
              <mat-form-field appearance="fill" class="calender-border cursor-pointer w-full"
                (click)="endPicker.open()">
                <mat-label>{{ 'DRIVE_IN_BOOKING.END_DATE' | transloco }}</mat-label>
                <input matInput [min]="minEndDate" [matDatepicker]="endPicker"
                  [formControl]="bookingDetailsForm.controls['endDate']">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                <mat-hint>{{ 'DRIVE_IN_BOOKING.END_DATE_HINT' | transloco }}</mat-hint>
              </mat-form-field>
              <div class="text-sm text-gray-500 mt-1 px-3">{{ 'DRIVE_IN_BOOKING.END_DATE_HINT' | transloco }}</div>
            </div>
            <!-- END TIME -->
            <div class="w-full">
              <mat-form-field appearance="fill" class="calender-border w-full">
                <mat-label>{{ 'DRIVE_IN_BOOKING.END_TIME' | transloco }}</mat-label>
                <input matInput type="text" placeholder="HH:mm" [formControl]="bookingDetailsForm.controls['endTime']"
                  (input)="onEndTimeInput($event)">
                <mat-icon matSuffix>alarm</mat-icon>
                @if (bookingDetailsForm.controls['endTime'].errors?.['pattern'] &&
                bookingDetailsForm.controls['endTime'].touched) {
                <mat-error>Format: HH:mm (e.g. 14:30)</mat-error>
                }
                <mat-hint>{{ 'DRIVE_IN_BOOKING.END_TIME_HINT' | transloco }}</mat-hint>
              </mat-form-field>
              <div class="text-sm text-gray-500 mt-1 px-3">{{ 'DRIVE_IN_BOOKING.END_TIME_HINT' | transloco }}</div>
            </div>
            <mat-form-field appearance="fill" class="calender-border w-full lg:col-span-2 calendar-border">
              <mat-label>{{ 'DRIVE_IN_BOOKING.EMAIL' | transloco }}</mat-label>
              <input matInput type="email" placeholder="example@gmail.com"
                [formControl]="bookingDetailsForm.controls['email']">
              <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
          </div>
          <!-- DETAILS SECTION -->
          <div #detailsSection class="lg:col-span-2 mt-4">
            <!-- PARKIING IS AVAILABLE -->
            @if (totalPrice !== false && totalPrice !== null) {
            <div class="rounded-2xl border border-green-600 bg-green-50 p-4">
              <div class="flex justify-between items-center">
                <div>
                  <h3 class="font-semibold text-green-700">
                    {{ 'DRIVE_IN_BOOKING.PARKING_PRICE' | transloco }}
                  </h3>
                  <span class="text-2xl font-bold text-green-700">
                    {{ totalPrice }} SEK
                  </span>
                </div>
                <mat-icon class="text-green-600">local_parking</mat-icon>
              </div>
            </div>
            }
            <!-- PARKING FULL -->
            @if (totalPrice == null) {
            <div class="rounded-2xl border border-red-600 bg-red-50 p-5">
              <span class="text-xl font-bold text-red-600">
                {{ 'DRIVE_IN_BOOKING.PARKING_IS_FULL' | transloco }}
              </span>
            </div>
            }
          </div>
          <!-- CONTINUE BUTTON -->
          <div class="grid grid-cols-1 lg:grid-cols-2 mt-6">
            <button type="button"
              class="py-3 rounded-3xl w-full lg:col-span-2 disabled:cursor-not-allowed disabled:opacity-70"
              [disabled]="!isContinueButtonEnabled || isLoading"
              [ngClass]="{'bg-[#397863] text-[#ffffff]': isContinueButtonEnabled && !isLoading, 'bg-[#dcdcdc] text-[#4B4A4A]': !isContinueButtonEnabled || isLoading}"
              (click)="createBooking()">
              <div class="flex gap-2 mx-3 justify-center items-center">
                @if ((driveInBookingForm.paymentRequired) == 'true') {
                <span>{{
                  'PARKIFLY.SUMMARY.TO_PAYMENT' | transloco }}</span>
                }
                @if ((driveInBookingForm.paymentRequired) == 'false') {
                <span>{{'DRIVE_IN_BOOKING.OPEN_GATE_AND_TO_PAYMENT'
                  | transloco }}</span>
                }
                <svg class="mt-[3px]" width="21" height="20" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{'fill-[#ffffff]': isContinueButtonEnabled, 'fill-[#4B4A4A]': !isContinueButtonEnabled}">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12.793 5.29303C12.9805 5.10556 13.2348 5.00024 13.5 5.00024C13.7652 5.00024 14.0195 5.10556 14.207 5.29303L18.207 9.29303C18.3945 9.48056 18.4998 9.73487 18.4998 10C18.4998 10.2652 18.3945 10.5195 18.207 10.707L14.207 14.707C14.0184 14.8892 13.7658 14.99 13.5036 14.9877C13.2414 14.9854 12.9906 14.8803 12.8052 14.6948C12.6198 14.5094 12.5146 14.2586 12.5123 13.9964C12.51 13.7342 12.6108 13.4816 12.793 13.293L15.086 11H3.5C3.23478 11 2.98043 10.8947 2.79289 10.7071C2.60536 10.5196 2.5 10.2652 2.5 10C2.5 9.73481 2.60536 9.48046 2.79289 9.29292C2.98043 9.10539 3.23478 9.00003 3.5 9.00003H15.086L12.793 6.70703C12.6055 6.5195 12.5002 6.26519 12.5002 6.00003C12.5002 5.73487 12.6055 5.48056 12.793 5.29303Z" />
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  }

  @if (showPaymentOption) {
  <div class="margin-top-bottom-20">
    <div class="UppgifterWrapper self-stretch flex-col justify-start items-start gap-4 inline-flex w-full">
      <div class="flex w-full justify-between">
        <div class="DinaUppgifter text-black text-lg font-bold  leading-loose">
          {{'PARKIFLY.PAYMENT.PAYMENT_METHOD' | transloco}}
        </div>
      </div>
      <label
        class="PaymentInput self-stretch  p-8 bg-white rounded-xl shadow flex-col justify-start items-start gap-4 flex">
        <div class="PaymentInput self-stretch w-full block">
          @if (!paymentLoadError) {
          <div class="mt-3 w-full" id="swedbank-pay-seamless-view-page"></div>
          }
          @if (paymentLoadError) {
          <div class="mt-3 w-full text-center p-4">
            <p class="mb-4 text-gray-600">{{ 'DRIVE_IN_BOOKING.PAYMENT_LOADING_ERROR' | transloco }}</p>
            <button mat-raised-button color="primary" (click)="getOrder()">
              {{ 'DRIVE_IN_BOOKING.RETRY' | transloco }}
            </button>
          </div>
          }
        </div>
      </label>
    </div>
  </div>
  }

</div>